export const BulkInviteErrors = {
  FIRSTNAME_REQUIRED: "First name is required.",
  LASTNAME_REQUIRED: "Last name is required.",
  EMAIL_REQUIRED: "Email is required",
  EMAIL_INVALID: "Email is improperly formatted.",
  EMAIL_EXISTS: "Existing email. Add User to program or delete this row.",
  NPI_REQUIRED_FOR_ROLE:
    "An NPI is required if the user is an Attending or Trainee.",
  NPI_INVALID:
    "NPI invalid. It must be a 10-digit number starting with 1",
  NPI_EXISTS: "Existing NPI. Add User to program or delete this row.",
  PROGRAMID_REQUIRED: "Program id is required",
  PROGRAMID_NOT_EXISTS: "No program with this programId exists.",
  ROLE_REQUIRED: "Role is required.",
  TRAINEE_TYPE_REQUIRED:
    "Trainee Type is required for users with the Trainee role",
  TRAINEE_TYPE_INVALID:
    "Must be one of: Categorical, DesignatedPreliminary, NonDesignatedPreliminary, Fellow, MedicalStudent",
  PGY_REQUIRED_FOR_ROLE: "A PGY is required if the user is a Trainee.",
  PGY_INVALID: "PGY is invalid"
};
